export default function ImagePlaceholder() {
  return (
    <div style={{ width: '100%', height: '100%', background: 'lightgray' }} />
  );
}
